<div
    class="mb-3  custom--input height_auto"
    [ngClass]="errorMessage ? 'has-error' : ''"
>
    <label class="control-label">
        <span *ngIf="labelText"
            >{{ labelText
            }}<span *ngIf="isRequired" class="help--text__danger">*</span></span
        >
        <fieldset [disabled]="isReadOnly">
            <span *ngIf="isChips" [formGroup]="inputFormGroup">
                <p-chips id="chips-with-placeholder" [ngClass]="isReadOnly ? 'custom-disabled-chips' : 'custom-enabled-chips'"
                [formControlName]="custContrlName" [addOnBlur]="false"
                [addOnTab]="true" (onRemove)="onChipsRemove($event)" (onAdd)="onChipsAdd($event)">
                </p-chips>
              <!-- Placeholder shown only when there are no chips -->
              <span
                *ngIf="!hidePlaceHolder" class="chips-placeholder">
                {{placeHolder}}
              </span>
            </span>
            <span *ngIf="hasControl && !isChips" [formGroup]="inputFormGroup">
                <textarea
                    #textAreaRef
                    [appAutofocus]="autoFocus"
                    [id]="rxID ? rxID : 'txtAreaID'"
                    [required]="isRequired"
                    [tabindex]="tabIndex"
                    autocomplete="off"
                    class="form-control custom--text__area"
                    [rows]="rows"
                    [cols]="cols"
                    [formControlName]="custContrlName"
                    [placeholder]="placeHolder"
                    [maxLength]="maxLength"
                    (blur)="triggerOnBlur($event)"
                    (keydown.tab)="triggerOnTab($event)"
                    (keyup.shift.tab)="onShiftTabbingEvent($event)"
                    (click)="getCursorPosition($event)"
                    (keyup)="getCursorPosition($event)"
                    (input)="onValueChange($event)"
                ></textarea>
            </span>
            <span *ngIf="!hasControl && !isChips">
                <textarea
                    #textAreaRef
                    [appAutofocus]="autoFocus"
                    [id]="rxID ? rxID : 'txtAreaID'"
                    [required]="isRequired"
                    [tabindex]="tabIndex"
                    autocomplete="off"
                    class="form-control custom--text__area"
                    [rows]="rows"
                    [cols]="cols"
                    [value]="inputValue"
                    [placeholder]="placeHolder"
                    [maxLength]="maxLength"
                    (blur)="triggerOnBlur($event)"
                    (keydown.tab)="triggerOnTab($event)"
                    (keyup.shift.tab)="onShiftTabbingEvent($event)"
                ></textarea>
            </span>
        </fieldset>
    </label>
    <div class="help-block" *ngIf="errorMessage">
        {{ errorMessage }}
    </div>
</div>
